/**
 * 机模屏幕「多静态图」栈的全局上限（首版标准）。
 * 可按产品策略调整；业务校验应引用本模块常量而非散落魔法数。
 */

/** 单张静态图最大边像素（宽、高均不得超过该值） */
export const MAX_SCREEN_IMAGE_EDGE_PX = 4096

/** 单图层多图栈最大张数 */
export const MAX_SCREEN_IMAGE_COUNT = 20
